const { items: wixData } = require('@wix/data');

const { COLLECTIONS } = require('../public/consts');
const { getDataBySlug } = require('../public/product/data');

async function updateSkuField(data) {
  const { slug, productId } = data;

  let productInCMS;
  let newSku;
  if (slug) {
    const { product, productInCMS: cmsProduct } = await getDataBySlug(slug);
    productInCMS = cmsProduct;
    newSku = product.sku;
  } else {
    productInCMS = await wixData.get(COLLECTIONS.CMS_PRODUCTS, productId);
    newSku = '';
  }

  if (!productInCMS || newSku === productInCMS.sku) {
    console.log('[updateSkuField] productInCMS not found or sku is the same, skipping');
    return;
  }

  const newDataToUpdate = {
    ...productInCMS,
    sku: newSku,
  };
  await wixData.save(COLLECTIONS.CMS_PRODUCTS, newDataToUpdate);
  console.log('[updateSkuField] SKU updated successfully');
}

module.exports = { updateSkuField };
